import { StepperClasskey, StyleRules } from "@material-ui/core";

export const MuiStepper: Partial<StyleRules<StepperClasskey, {}>> = {
  root: {
    padding: "0 10px",
  },
};
